import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validityDayValidator(validityKey: string, daysKey: string, validityDefinitiveValue: any): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validityControl = control.get(validityKey);
    const daysControl = control.get(daysKey);
    if (validityControl && daysControl) {
      if (validityControl.value === validityDefinitiveValue) { // Si es definitivo
        return null;
      }
      if (daysControl.value > 0) {
        return null;
      }
      return {
        description: 'Debe ingresar un dia mayor o igual a 1',
        code: '300',
      };
    }
    return null;
  };
}
